import StreamlinedPayments from './StreamlinedPayments';

export default StreamlinedPayments;
